import React from "react";
import classnames from 'classnames';
import Jump from "./animations/Jump";
import logo from "../assets/images/llama_diorama.png"

const Logo = ({...props}) => {
    return (
        <Jump duration="1s" delay="5s">
        <img src={logo} {...props} />
        </Jump>
    );
};

export default Logo;
